<template>
    <div class="row">
        <div class="col-sm-8 col-sm-offset-2">
            <div id="qrCodesX2">
                <div v-if="printTagOn" id="qrRenderX2" :style="containerStyle">
                    <!-- Order variant: full address tag + QR (unchanged from legacy) -->
                    <template v-if="tagType == 'order'">
                        <div id="renderDiv">
                            <div  id="qrGen">
                                <canvas id="genCanvas"></canvas>
                                {{ renderQrCode('genCanvas', tagData.order_no) }}
                            </div>
                        </div>
                        <div style="margin-top: 5px; text-align: left; font: 12pt Helvetica; line-height: 1;">
                            <span><strong>{{ tagData.order_no }}</strong></span>
                        </div>
                        <div style="margin-right: 80px; text-align: left; font: 9pt Helvetica; line-height: 1.5;">
                            <span style="font-size: 10pt !important;"><strong>{{ tagData.client_name }}</strong></span><br>
                            <span style="font-size: 10pt !important;"><strong>{{ tagData.contact_person }}</strong></span><br>
                            <span style="word-wrap: break-word;  overflow-wrap: break-word;"><strong>{{ tagData.address }}</strong></span><br>
                            <span style="word-wrap: break-word;  overflow-wrap: break-word;"><strong>{{ tagData.city }}</strong></span><br>
                            <span style="word-wrap: break-word;  overflow-wrap: break-word;"><strong>{{ tagData.province }}</strong></span><br>
                            <span style="word-wrap: break-word;  overflow-wrap: break-word;"><strong>{{ tagData.postal_code }}</strong></span><br>
                            <span style="word-wrap: break-word;  overflow-wrap: break-word;"><strong>Tel: {{ tagData.contact_no }}</strong></span>
                        </div>
                    </template>
                    <!-- Hospitality variant: text-only, product name (+ optional batch no), no QR -->
                    <template v-else-if="tagType == 'hospitality'">
                        <div style="text-align: left; font: 16pt Helvetica; line-height: 1.3; word-wrap: break-word; overflow-wrap: break-word;">
                            <span><strong>{{ tagData.product_name }}</strong></span>
                        </div>
                        <div v-if="tagData.batch_no" style="margin-top: 10px; text-align: left; font: 11pt Helvetica; line-height: 1.3; word-wrap: break-word; overflow-wrap: break-word;">
                            <span>Batch: {{ tagData.batch_no }}</span>
                        </div>
                    </template>
                    <!-- Bulk variant: text-only, client name + product name, no QR -->
                    <template v-else-if="tagType == 'bulk'">
                        <div style="text-align: left; font: 14pt Helvetica; line-height: 1.3; word-wrap: break-word; overflow-wrap: break-word;">
                            <span><strong>{{ tagData.client_name }}</strong></span>
                        </div>
                        <div style="margin-top: 8px; text-align: left; font: 12pt Helvetica; line-height: 1.3; word-wrap: break-word; overflow-wrap: break-word;">
                            <span>{{ tagData.product_name }}</span>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as html2pdf from "../../../plugins/html2pdf/html2pdf.bundle.min";
import QRCode from 'qrcode'
import _ from 'lodash';
let htmlWorker = null;
export default {
    data: () => ({
        printTagOn: false,
        renderCount: 0,
        tagType: "",
        tagData: {},
        printJob: []
    }),
    methods: {
        printTag: function (obj) {
            this.$eventHub.$emit('setBusyPrinting', true);
            _.forEach(obj, function (value, key) {
                obj[key]['printed'] = false;
            })
            this.printJob = obj;
            this.handlePrintJob();
        },
        handlePrintJob() {
            let el = this;
            let unfinishedIndex = _.findIndex(this.printJob, function (o) { return o.printed == false; });
            if (unfinishedIndex > -1) {
                //there are unfinished print jobs
                let job = this.printJob[unfinishedIndex];
                //Resolve the effective label type. Legacy order jobs carry `type` only (no
                //`label_type`), so fall back to `type` to keep those callers working untouched.
                let labelType = job.label_type || job.type;
                this.tagType = labelType;
                //Reset so stale fields from a prior job/type cannot bleed into this render.
                this.tagData = {};
                if (labelType == "order") {
                    this.tagData['order_no'] = job.order_no;
                    this.tagData['tracking_src'] = job.tracking_src;
                    this.tagData['address'] = job.address;
                    this.tagData['city'] = job.city;
                    this.tagData['province'] = job.province;
                    this.tagData['postal_code'] = job.postal_code;
                    this.tagData['contact_person'] = job.contact_person;
                    this.tagData['contact_no'] = job.contact_no;
                    this.tagData['client_name'] = job.client_name;
                } else if (labelType == "hospitality") {
                    this.tagData['product_name'] = this.truncate(job.product_name, 40);
                    if (job.batch_no) {
                        this.tagData['batch_no'] = this.truncate(job.batch_no, 24);
                    }
                } else if (labelType == "bulk") {
                    this.tagData['client_name'] = this.truncate(job.client_name, 40);
                    this.tagData['product_name'] = this.truncate(job.product_name, 40);
                } else {
                    //Unknown/blank label type: skip rather than rasterize and POST a
                    //blank label. Mark handled and advance the sequential queue.
                    //eslint-disable-next-line
                    console.error('tagPrint: unknown label type, skipping job:', labelType);
                    this.printJob[unfinishedIndex].printed = true;
                    this.handlePrintJob();
                    return;
                }
                //Render tag
                this.printTagOn = true;

                this.$nextTick(() => {
                    let pageFormat =   [140, 100]; //[50, 60];
                    let opt = {
                        margin: [0, 0, 0, 0],
                        filename: 'test.pdf',
                        image: { type: 'jpeg', quality: 1 },
                        html2canvas: { scale: 1 },
                        pagebreak: { mode: 'avoid-all' },
                        jsPDF: { unit: 'mm', format: pageFormat, orientation: 'portrait' }
                    };
                    setTimeout(function () {
                        let element = document.getElementById('qrRenderX2');
                        htmlWorker = html2pdf();
                        htmlWorker.set(opt).from(element).outputImg('datauristring').then(function (pdfAsString) {
                            el.pushToPrinter(pdfAsString, unfinishedIndex, el.tagType);
                        });
                    }, 350);
                });
            } else {
                this.$eventHub.$emit('setBusyPrinting', false);
            }
        },
        pushToPrinter: function (base64, unfinishedIndex, type) {
            this.printTagOn = false;
            window.axios.post('api/orders/print_tags', { file: base64, type: type })
            .then(() => {
                this.printJob[unfinishedIndex].printed = true;
                this.handlePrintJob();
            })
            .catch(e => {
                //eslint-disable-next-line
                console.log(e);
            });
        },
        renderQrCode(element, qrStr) {
            setTimeout(function () {
                let canvas = document.getElementById(element);
                QRCode.toCanvas(canvas, qrStr, { errorCorrectionLevel: 'L', width: 125, margin: 1 }, function (error) {
                    //eslint-disable-next-line
                    if (error) console.error(error);
                });
            }, 150);
        },
        //Unicode-safe, code-point-aware truncation so surrogate-pair / non-Latin
        //characters are never split mid-glyph and content cannot overflow the fixed label.
        truncate(str, max) {
            if (str === undefined || str === null) return '';
            let chars = Array.from(String(str));
            if (chars.length <= max) return chars.join('');
            //Reserve one code point for the ellipsis so total output stays within budget.
            return chars.slice(0, Math.max(0, max - 1)).join('') + '…';
        }
    },
    computed: {
        //Order keeps its exact legacy padding; text-only variants use lighter padding
        //(no QR block to offset). Object form so the order render stays pixel-identical.
        containerStyle() {
            if (this.tagType == 'order') {
                return {
                    'text-align': 'left',
                    'padding-left': '2px',
                    'padding-right': '100px',
                    'padding-top': '180px',
                    'padding-bottom': '150px'
                };
            }
            return {
                'text-align': 'left',
                'padding-left': '20px',
                'padding-right': '20px',
                'padding-top': '40px',
                'padding-bottom': '40px'
            };
        }
    },
    created: function () {
        this.$eventHub.$on('printTag', this.printTag);
    },
    beforeDestroy: function () {
        htmlWorker = null;
        this.$eventHub.$off('printTag');
    }
};
</script>
<style lang="scss" scoped>
#renderDiv {
    display: inline !important;
    margin-top: 8px;
}
.rotate {
    transform: rotate(-90deg);
    /* Legacy vendor prefixes that you probably don't need... */
    /* Safari */
    -webkit-transform: rotate(-90deg);
    /* Firefox */
    -moz-transform: rotate(-90deg);
    /* IE */
    -ms-transform: rotate(-90deg);
    /* Opera */
    -o-transform: rotate(-90deg);
}
</style>